import { q } from "../../helper/q"
import hyperform from "hyperform"

export const promoFormInit = () => {
  const formElement = q(".promotionsSubscriptionForm")

  if (formElement) {
    hyperform.setRenderer("attachWarning", function(warning, element) {
      element.parentNode.classList.add("floatInputError")
      element.parentNode.querySelector(".floatInputLabel").innerHTML = warning.innerHTML
    })
    hyperform(formElement)
    formElement.addEventListener("submit", event => {
      event.preventDefault()
      event.stopPropagation()
      if (hyperform.checkValidity(formElement)) {
        const button = formElement.querySelector('button[type="submit"]')
        button.style.width = button.offsetWidth + "px"
        button.innerHTML = loader

        const formHeight = formElement.parentNode.offsetHeight + "px"
        sendForm(formElement).then(resss => {
          if (resss.result === "success") {
            formElement.parentNode.innerHTML = `<div class="promotionsSubscriptionText" style="height: ${formHeight}">${
              resss.successMessage
            }</div>`
          }
          if (resss.result === "error") {
            formElement.parentNode.innerHTML = `<div class="promotionsSubscriptionErrorText" style="height: ${formHeight}">${
              resss.errorMessage
            }</div>`
          }
        })
      }
    })
    formElement.addEventListener("invalid", () => {
      q("button", formElement).disabled = true
    })
    formElement.addEventListener("valid", () => {
      q("button", formElement).disabled = false
    })
  }
}

const sendForm = form => {
  const formData = new FormData(form)
  const options = {
    method: "POST",
    credentials: "include",
    body: formData
  }
  return fetch(form.action, options).then(res => res.json())
}

const loader = /* html */ `<div class="spinner">
<div class="bounce1"></div>
<div class="bounce2"></div>
<div class="bounce3"></div>
</div>`
